export default {
      id: "icon--chevron-dark-grey-usage",
      viewBox: "0 0 13 7",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--chevron-dark-grey-usage",
      toString: function () {
        return this.url;
      }
    }